<script lang="ts">
	import type { PointsInfoBannerContent } from '../../domain/points-info-banner/PointsInfoBannerContent.ts';
	import type { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';
	import { onMount } from 'svelte';
	import TrackingService, { ActionName } from '../../services/tracking/TrackingService.ts';
	import { Topic } from '../../services/tracking/Topic.ts';
	import { onViewport } from '../../services/tracking/IntersectionObserver';
	import { sheetV1 } from '@otto-ec/otto-components/sheet';


	let trackingService: TrackingService;

	let { pointsInfoBannerContent, pointsInfoBannerType, enableSignupSheetMigration }: {
		pointsInfoBannerContent: PointsInfoBannerContent,
		pointsInfoBannerType: PointsInfoBannerType,
		enableSignupSheetMigration: boolean
	} = $props();

	const trackClick = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.OPEN],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const trackSeen = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.SEEN],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const trackView = () => {
		trackingService.sendEvent(Topic.MergeEvent, {
			up_PointsBanner: [ActionName.VIEW],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const createSheet = async () => {
		if (!enableSignupSheetMigration) {
			/*         */
			/*                                */
			const pointsInfoBannerSheet = new o_global.pali.sheet({
				title: pointsInfoBannerContent.sheetTitle,
				url: pointsInfoBannerContent.sheetUrl,
				fullBleedContent: true
			});
			pointsInfoBannerSheet.open()
			return;
		}

		await sheetV1.create({
			open: true,
			id: 'points-info-banner-sheet',
			headline: pointsInfoBannerContent.sheetTitle,
			url: pointsInfoBannerContent.sheetUrl,
			noContentPadding: true
		});
	}

	const click = async () => {
		trackClick();
		await createSheet();
	}

	onMount(() => {
		trackingService = new TrackingService();
		trackView();
	});

</script>
<div class="points-info-banner"
	id="points-info-banner"
	data-testid="points-info-banner"
	data-sheet-full-bleed-content="true"
	style="cursor: pointer; display:flex;"
	data-points-info-banner-type={pointsInfoBannerType}
	onmousedown={trackSeen}
	use:onViewport
	onenterViewport={trackSeen}
>
	<svg class="pl_icon100 oc-mr-75" role="img">
		<use
			data-testid="pl_icon_otto-up-points"
			href="/assets-static/icons/pl_icon_otto-up-points.svg#pl_icon_otto-up-points"
			xlink:href="/assets-static/icons/pl_icon_otto-up-points.svg#pl_icon_otto-up-points"></use>
	</svg>
	<oc-link-v2
		variant="secondary"
		data-testid="points-info-banner-description"
		onclick={click}
	>
		<a href="#">{@html pointsInfoBannerContent.description}</a>
	</oc-link-v2>
</div>
